import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import TanStackTable from './TanStackTable';

const BulkActionResults = ({ results, actionType = "deletion", onClose }) => {
  if (!results) return null;

  const gridHeight = '200px'; // Fixed height for grids
  const gridStyle = {
    height: gridHeight,
    width: '100%',
  };

  return (
    <Box 
      sx={{ 
        mt: 2,
        mb: 2,
        backgroundColor: 'background.paper',
        borderRadius: 1,
        border: '1px solid',
        borderColor: 'divider',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      {/* Header with close button */}
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',
        p: 1,
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}>
        <Typography variant="h6">
          Bulk {actionType} Results
        </Typography>
        <IconButton 
          onClick={onClose}
          size="small"
          sx={{ color: 'text.secondary' }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Content */}
      <Box sx={{ p: 1 }}>
        {/* Successes */}
        <Typography variant="body2" sx={{ mb: 1 }}>
          Successful {actionType}s ({results.successes?.length || 0})
        </Typography>
        <Box sx={{ mb: 2, height: gridHeight }}>
          <TanStackTable
            data={results.successes || []}
            columns={[
              { header: 'ID', accessorKey: 'id' },
              { header: 'Name', accessorKey: 'name' },
            ]}
          />
        </Box>

        {/* Failures */}
        {results.failures?.length > 0 && (
          <>
            <Typography variant="body2" sx={{ mb: 1, color: 'error.main' }}>
              Failed {actionType}s ({results.failures.length})
            </Typography>
            <Box sx={{ height: gridHeight }}>
              <TanStackTable
                data={results.failures || []}
                columns={[
                  { header: 'ID', accessorKey: 'id' },
                  { header: 'Name', accessorKey: 'name' },
                  { header: 'Error', accessorKey: 'error' }
                ]}
              />
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default BulkActionResults;
